import React from 'react';

/**
 * Loading spinner component
 * @param {Object} props - Component props
 * @param {string} props.size - Size of the spinner ('small', 'medium', 'large')
 * @param {string} props.color - Color of the spinner
 * @returns {JSX.Element} Loading spinner component
 */
const LoadingSpinner = ({ size = 'medium', color = '#2980B9' }) => {
  // Determine size dimensions
  const dimensions = {
    small: { width: '20px', height: '20px', border: '3px' },
    medium: { width: '30px', height: '30px', border: '4px' },
    large: { width: '40px', height: '40px', border: '5px' },
  }[size];
  
  const spinnerStyle = {
    width: dimensions.width,
    height: dimensions.height,
    border: `${dimensions.border} solid #f3f3f3`,
    borderTop: `${dimensions.border} solid ${color}`,
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '20px auto',
  };
  
  // Add keyframes animation
  const keyframesStyle = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  
  return (
    <div style={{ textAlign: 'center' }}>
      <style>{keyframesStyle}</style>
      <div style={spinnerStyle} aria-label="Loading" role="status"></div>
    </div>
  );
};

export default LoadingSpinner;